import { render } from "./NavBarItemLabel.vue?vue&type=template&id=51e1f132"
import script from "./NavBarItemLabel.vue?vue&type=script&lang=js"
export * from "./NavBarItemLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__